import { makeStyles } from '@material-ui/core/styles';

export const newTableStyles = makeStyles((theme) => ({
    groupHeaderRow: {
        display: 'flex',
        flexShrink: 0,
    },
    groupHeaderCell: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 8px',
        background: theme.palette.primary.light,
        border: `0.5px solid ${theme.palette.divider}`,
        color: theme.palette.primary.main,
        fontWeight: 500,
        textTransform: 'uppercase',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    groupHeaderCellLast: {
        flex: 1,
    },
}));
